require([
],
    function () {

        function hideEmptyPageSections() {
            // process all page sections on the page
            $(".page-section").each(function (index, section) {
                if ($(section).find(".page-section-wrapper").html().trim().length === 0) {
                    // section is empty - hide it
                    $(section).addClass("d-none");
                }
            });
        }

        hideEmptyPageSections();

    }
);

define("PageSection/main", function(){});

